import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { red, grey } from "@mui/material/colors";
import { notification } from "../../../utils/Notifications";
import {
  Button,
  Container,
  Dialog,
  Typography,
  TextField,
  CircularProgress,
  Switch,
  FormControlLabel,
  Grid,
} from "@mui/material";
import { createCategory } from "../../../api/categoriesApi.js";
import styles from "./newCategoryStyles.js";

NewCategoryDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function NewCategoryDialog({ onClose, open, fetchCategories }) {

  const [name, setName] = useState("");
  const [liberDiscount, setLiberDiscount] = useState("");
  const [thirdDiscount, setThirdDiscount] = useState("");
  const [productBuyDiscount, setProductBuyDiscount] = useState("");
  const [storageDiscount, setStorageDiscount] = useState("");
  const [supplierNotification, setSupplierNotification] = useState(false);
  const [clientsNotification, setClientsNotification] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateField = (value, fieldName) => {
    /* let error = "";
    if (!/^\d+$/.test(value)) {
      error = "El valor debe ser un número entero positivo";
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: error,
    }));
    return !error; */
  };

  const handleNameChange = (event) => setName(event.target.value);
  const handleLiberDiscountChange = (event) => {
    setLiberDiscount(event.target.value);
    validateField(event.target.value, "liberDiscount");
  };

  const handleThirdDiscountChange = (event) => {
    setThirdDiscount(event.target.value);
    validateField(event.target.value, "thirdDiscount");
  };

  const handleProductBuyDiscountChange = (event) => {
    setProductBuyDiscount(event.target.value);
    validateField(event.target.value, "productBuyDiscount");
  };

  const handleStorageDiscountChange = (event) => {
    setStorageDiscount(event.target.value);
    validateField(event.target.value, "storageDiscount");
  };
  const handleSupplierNotification = (event) =>
    setSupplierNotification(event.target.checked);
  
  const handleClientsNotification = (event) =>
    setClientsNotification(event.target.checked);

  const clearFields = () => {
    setName("");
    setLiberDiscount("");
    setThirdDiscount("");
    setProductBuyDiscount("");
    setStorageDiscount("");
    setSupplierNotification(false);
    setClientsNotification(false);
    setErrors({});
  };

  const handleCreateAdminClick = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    createCategory(
      name,
      liberDiscount,
      thirdDiscount,
      productBuyDiscount,
      storageDiscount,
      supplierNotification,
      clientsNotification
    )
      .then((response) => {
        if (response.data.status_Code === 200 && response.data.status_Message === "membership name isn't available") {
          notification({ text: "El nombre ya esta en uso", type: "error" });
          setIsLoading(false);
          return;
        }
        
        if (response.data.status_Code === 201) {
          notification({ text: "Categoría creada", type: "success" });
          fetchCategories();
          setIsLoading(false);
          onClose();
        } else {
          setIsLoading(false);
          notification({
            text: "Error al crear la categoría",
            type: "error",
          });
        }
      })
      .catch(() => {
        setIsLoading(false);
        clearFields();
        onClose();
        notification({
          text: "Error de conexión, revisa tu conexión a internet",
          type: "error",
        });
      });
  };

  useEffect(() => {
    const validateForm = () => {
      const isValid =
        name &&
        liberDiscount &&
        thirdDiscount &&
        productBuyDiscount &&
        storageDiscount;
      const hasNoErrors =
        !errors.name &&
        !errors.liberDiscount &&
        !errors.thirdDiscount &&
        !errors.productBuyDiscount &&
        !errors.storageDiscount;
      setIsFormValid(isValid && hasNoErrors);
    };

    validateForm();
  }, [
    name,
    liberDiscount,
    thirdDiscount,
    productBuyDiscount,
    storageDiscount,
    errors,
  ]);

  useEffect(() => {
    if (!open) {
      clearFields();
    }
  }, [open]);

  const buttonStyles = {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
  };

  const activeButtonStyles = {
    ...buttonStyles,
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  };

  const inactiveButtonStyles = {
    ...buttonStyles,
    backgroundColor: grey[500],
    color: grey[300],
  };

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: styles.dialog }}
    >
      <Container sx={styles.mainContainer}>
        <Typography component="div" variant="h5" style={styles.title}>
          Nueva categoría
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <TextField
              id="standard-basic"
              label="* Nombre"
              variant="standard"
              value={name}
              onChange={handleNameChange}
              error={!!errors.name}
              helperText={errors.name}
              inputProps={{ maxLength: 50 }}
              style={styles.textfield}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="standard-basic"
              label="* Descuento Liber"
              variant="standard"
              type="number"
              value={liberDiscount}
              onChange={handleLiberDiscountChange}
              error={!!errors.liberDiscount}
              helperText={errors.liberDiscount}
              style={styles.textfield}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="standard-basic"
              label="* Descuento de terceros"
              variant="standard"
              type="number"
              value={thirdDiscount}
              onChange={handleThirdDiscountChange}
              error={!!errors.thirdDiscount}
              helperText={errors.thirdDiscount}
              style={styles.textfield}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="standard-basic"
              label="* Descuento en productos"
              variant="standard"
              type="number"
              value={productBuyDiscount}
              onChange={handleProductBuyDiscountChange}
              error={!!errors.productBuyDiscount}
              helperText={errors.productBuyDiscount}
              style={styles.textfield}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="standard-basic"
              label="* Descuento en almacenamiento"
              variant="standard"
              type="number"
              value={storageDiscount}
              onChange={handleStorageDiscountChange}
              error={!!errors.storageDiscount}
              helperText={errors.storageDiscount}
              style={styles.textfield}
              fullWidth
            />
          </Grid>
        </Grid>

        <FormControlLabel
          sx={styles.checkSuppliers}
          control={
            <Switch
              checked={supplierNotification}
              onChange={handleSupplierNotification}
            />
          }
          label="Notificaciones de proveedores"
        />
        <FormControlLabel
          sx={styles.checkClients}
          control={
            <Switch
              checked={clientsNotification}
              onChange={handleClientsNotification}
            />
          }
          label="Notificaciones de clientes"
        />

        <Container style={styles.buttonsContainer}>
          <Button
            variant="standard"
            color="primary"
            onClick={handleDialogClose}
            style={styles.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            disabled={!isFormValid}
            onClick={handleCreateAdminClick}
            sx={isFormValid ? activeButtonStyles : inactiveButtonStyles}
          >
            {isLoading ? (
              <CircularProgress size={24} style={styles.circularProgress} />
            ) : (
              "Crear"
            )}
          </Button>
        </Container>
      </Container>
    </Dialog>
  );
}
